import { CHAIN_ID } from './networks'

export type AddressMap = Partial<Record<CHAIN_ID, string>>

export default {
  multiCall: {
    1: '0x2a80799F88896E16f963284C7583f365CD645A1B',
    5: '0x925452ab590bdE90800a6265b4C6E16983194C25',
    56: '0xfF6FD90A470Aaa0c1B8A54681746b07AcdFedc9B',
    97: '0x8F3273Fb89B075b1645095ABaC6ed17B2d4Bc576',
  },
  purchaseCashierContr: {
    1: '0x321495D8f87DFe63623C46398E707f6D12eA32eC',
    5: '',
    56: '0x321495D8f87DFe63623C46398E707f6D12eA32eC',
    97: '0xdC090CB525Ae52e42d0db7287b02aB5bE2A7e5D4'
  },
  nftClaimHandlerContr: {
    1: '0xa6D24B9BE19b702F261f16db1fF1693d435503af',
    5: '0x741802C3381D3384Dacf973CC7Bf820e31D581B6',
    56: '',
    97: ''
  },
  tokenClaimHandlerContr: {
    1: '0x5F4922A7b781cb763A9c98402C90980a074828a2',
    5: '0x69EA5017FEeBeaC204760AD24F264B63B6790Ba5',
    56: '',
    97: ''
  },
}
